// ======================================================================
// File Name       : ContentVideoContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getVideoList } from '../../actions/content/ContentVideoAction';
import DialogConfirm from '../../components/DialogConfirm';
import MessageSearch from '../../components/MessageSearch';
import PaginationCustom from '../../components/Pagination';
import ContentVideoList from '../../components/content/ContentVideoList';
import ContentVideoSearch from '../../components/content/ContentVideoSearch';
import { DEFAULT_DATE_FORMAT_SERVER, RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import * as ICON from '../../constants/IconConstants';
import Header from '../../components/Header';
class ContentVideoContainer extends Component {
  constructor() {
    super();
    this.state = {
      contentSearchInfo: {
        contentSecernId: '',
        contentName: '',
        videoStatus: null,
        createdDateFrom: '',
        createdDateTo: '',
        dataAffiliationType: -1,
        ascendingDescendingSort: null,
        startPosition: 0,
        videoSortType: null,
        returnMaxNum: RETURN_MAX_NUM,
        createdUserName: '', // Step 9.0.0
      },
      recordNum: 0,
      contentVideoSearchResult: null,
      videoInfo: {
        videoList: [],
      },
      isAllowShowSearchMessage: false,
      currentSearch: {
        dataAffiliationType: -1,
      },
      isInit: true,
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.openCSVExportConfirm = this.openCSVExportConfirm.bind(this);
    this.onCSVExportCancel = this.onCSVExportCancel.bind(this);
    this.onCSVExportOk = this.onCSVExportOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePublicTimeChange = this.handlePublicTimeChange.bind(this);
    this.validation = this.validation.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    if (this.props.parentPath === Path.CONTENT_VIDEO_LIST) {
      this.setState({
        ...this.state,
        contentSearchInfo: this.props.searchCondition,
        currentSearch: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.getContentList(SELECT_TARGET_DATA.DATA);
  }

  componentWillReceiveProps(nextProps) {
    const { content } = nextProps;
    const { videoInfo } = content;
    this.setState({
      videoInfo,
    });
  }

  componentWillUnmount() {
    const searchCondition = this.state.currentSearch;
    searchCondition.startPosition = this.state.contentSearchInfo.startPosition;
    searchCondition.videoSortType = this.state.contentSearchInfo.videoSortType;
    searchCondition.ascendingDescendingSort = this.state.contentSearchInfo.ascendingDescendingSort;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_VIDEO_LIST,
      searchCondition,
    });
  }


  /**
   * Get content list when click button search
   */
  onSearchData() {
    if (!this.validation()) {
      return;
    }
    this.getContentList(SELECT_TARGET_DATA.DATA);
  }

  /**
     * Get content list
     *
     * @param {integer} selectTargetData
     */
  getContentList(selectTargetData) {
    if (!this.validation()) {
      return;
    }
    const { returnMaxNum, currentSearch } = this.state;
    const dataAffiliationType = parseInt(this.state.currentSearch.dataAffiliationType, 10);
    const param = {
      selectTargetData,
      searchInfo: {
        contentSecernId: currentSearch.contentSecernId || null,
        contentName: currentSearch.contentName || null,
        videoStatus: !isNaN(currentSearch.videoStatus)
          ? parseInt(currentSearch.videoStatus, 10) : null,
        createdDateFrom:
          currentSearch && currentSearch.createdDateFrom
            ? moment(currentSearch.createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
            : undefined,
        createdDateTo: currentSearch && currentSearch.createdDateTo
            ? moment(currentSearch.createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
            : undefined,
        dataAffiliationType: dataAffiliationType > -1 ? dataAffiliationType : null,
        videoSortType: this.state.contentSearchInfo.videoSortType,
        ascendingDescendingSort: this.state.contentSearchInfo.ascendingDescendingSort,
        startPosition: this.state.contentSearchInfo.startPosition || 0,
        returnMaxNum: returnMaxNum || RETURN_MAX_NUM,
        createdUserName: currentSearch.createdUserName || null, // Step 9.0.0
      },
    };

    this.props.dispatch(getVideoList(param)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  /**
     * handle change for user input
     * @param {*} event
     */
  handleChange(event) {
    const { name, value } = event.target;
    const contentSearchInfo = { ...this.state.contentSearchInfo, ...{ [name]: value } };
    this.setState({ contentSearchInfo });
  }

  handlePublicTimeChange(name, value) {
    const contentSearchInfo = { ...this.state.contentSearchInfo, ...{ [name]: value } };
    this.setState({
      contentSearchInfo,
    });
  }

  /**
     * Open dialog confirm export CVS file
     */
  openCSVExportConfirm(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
     * handle on Cancel click to export CVS file
     */
  onCSVExportCancel() {
    this.setState({ showModal: false });
  }

  /**
     * handle on OK click to export CVS file
     */
  onCSVExportOk() {
    // ToDo: send data  etc ....
    this.setState({ showModal: false });
    this.getContentList(1);
  }

  /**
     * Pagination
     * @param {*} page
     */
  getStartEndData(startPosition) {
    if (!this.validation()) {
      return;
    }
    const contentSearchInfo = {
      ...this.state.contentSearchInfo,
      ...{ startPosition },
    };
    this.setState(
      {
        contentSearchInfo,
      }, () => { this.onSearchData(); },
    );
  }

  handleSearchBtn() {
    if (!this.validation()) {
      return;
    }
    const contentSearchInfo = {
      ...this.state.contentSearchInfo,
      ...{ startPosition: 0 },
      ...{ ascendingDescendingSort: null },
      ...{ videoSortType: null },
    };
    const currentSearch = {
      ...this.state.contentSearchInfo,
      ...(this.state.currentSearch = this.state.contentSearchInfo),
    };
    this.setState({
      contentSearchInfo,
      currentSearch,
      isInit: false,
    }, () => { this.onSearchData(); },
    );
  }

  /**
     * handle sorting data
     * @param {*} row
     */
  handleSortState(row) {
    if (!this.validation()) {
      return;
    }
    const contentSearchInfo = {
      ...this.state.contentSearchInfo,
      videoSortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    };
    this.setState(
      { contentSearchInfo },
      () => {
        this.getContentList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    this.refsToValidate = [];
    const recordNum = this.state.videoInfo ? this.state.videoInfo.recordNum : 0;
    const contentList = this.state.videoInfo ? this.state.videoInfo.contentList : [];
    const { hoverIndex } = this.state;
    return (
      <div>
        <Header name='ビデオ' />
        <MessageSearch
          recordNum={recordNum}
          resultList={contentList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ContentVideoSearch
          {...this.state.contentSearchInfo}
          recordNum={this.state.videoInfo ? this.state.videoInfo.recordNum : 0}
          startPosition={this.state.contentSearchInfo.startPosition}
          handleChange={this.handleChange}
          handlePublicTimeChange={this.handlePublicTimeChange}
          getStartEndData={this.getStartEndData}
          onSearchBtnClick={this.handleSearchBtn}
          onExportBtnClick={this.openCSVExportConfirm.bind(this, MessageTemplate.BULK_EXPORT, null)}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
        <ContentVideoList
          videoInfo={this.state.videoInfo}
          handleSortState={this.handleSortState}
          contentSearchInfo={this.state.contentSearchInfo}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
          recordNum={recordNum}
          startPosition={this.state.contentSearchInfo.startPosition}
          getStartEndData={this.getStartEndData}
        />
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onCSVExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onCSVExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  return ({
    ...{ content: state.content },
    parentPath,
    searchCondition,
  });
};

export default connect(mapStateToProps)(ContentVideoContainer);
